<div class="content">
  <div class="title">{{ 'no-permission.title' | mTranslate }}</div>
  <div class="subtitle">
    <span>{{ 'no-permission.subtitle1' | mTranslate }}</span>
    <span>{{ 'no-permission.subtitle2' | mTranslate }}</span>
  </div>
  <div class="option-button">
    <button m-button class="button" buttonType="outline">
      <span>{{ 'no-permission.button-exit' | mTranslate }}</span>
    </button>
  </div>
</div>
